import styled from 'styled-components';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;

  textarea {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    align-self: stretch;
    border-radius: 4px;
    border-color: #ced4da;
    padding: 8px 12px;
    resize: vertical; /* Allow only vertical resizing */
    overflow-x: hidden; /* Hide any horizontal overflow */
    min-height: 100px;

    &::focus {
      border-color: #228be6 !important;
      outline: #228be6 !important;
    }

    &:placeholder {
      color: #adb5bd;
    }
  }
`;

export const Label = styled.label`
  color: #25262b;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
`;
